import {Component, OnInit} from '@angular/core';
import SwiperCore, {A11y, EffectFade, Navigation, Pagination, Scrollbar, SwiperOptions} from 'swiper';
import {AbstractComponent} from "../abstract.component";
import {RaceService} from "@services";
import {ActionResultList, Race} from "@model";

// install Swiper modules
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, EffectFade]);

@Component({
  selector: 'app-featured-race-carousel',
  templateUrl: './featured-race-carousel.component.html',
  styleUrls: ['./featured-race-carousel.component.scss'],
})
export class FeaturedRaceCarouselComponent extends AbstractComponent implements OnInit {

  config: SwiperOptions = {
    initialSlide: 0,
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: true,
    pagination: false,
    scrollbar: {draggable: false},
    breakpoints: {
      1024: {
        slidesPerView: 3,
      }
    }
  };

  recommendedRaces: Race[] = [];

  constructor(private raceService: RaceService) {
    super();
  }

  ngOnInit(): void {
    this.subscriptions.push(this.raceService.recommendedRaces.subscribe((value: ActionResultList<Race[], number> | null) => {
      if (value != null && value.result)
        this.recommendedRaces = value.result.slice(0, 5);
    }));
  }
}
